import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { clearHubSession, hubExchange, hubWorkspaces } from '../api'

/**
 * Fallback route: if someone lands here with a hub token, open the primary
 * workspace automatically (same order as login — Super Admin first).
 */
export default function WorkspacesPage() {
  const navigate = useNavigate()
  const [error, setError] = useState('')
  const [email, setEmail] = useState('')

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      setError('')
      try {
        const data = await hubWorkspaces()
        if (cancelled) return
        setEmail(data.user?.email || '')
        const list = data.workspaces || []
        if (!list.length) {
          setError(
            'No workspace linked to this email yet. Contact support@gosnel.com if you need access.',
          )
          return
        }
        const exchanged = await hubExchange(list[0].id)
        if (cancelled) return
        if (exchanged.redirect_url) {
          window.location.href = exchanged.redirect_url
          return
        }
        setError('This account has no portal URL yet. Contact support@gosnel.com.')
      } catch (err) {
        if (cancelled) return
        setError(err instanceof Error ? err.message : 'Could not continue')
        clearHubSession()
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="shell">
      <div className="card">
        <div className="brand">
          <img src="/gosnel-logo.png" alt="GoSnel" />
          <div>
            <h1>GoSnel</h1>
            <p>Life, simplified</p>
          </div>
        </div>
        {email ? <p className="email-chip">{email}</p> : null}
        {error ? (
          <>
            <div className="alert error">{error}</div>
            <button
              type="button"
              className="btn secondary"
              onClick={() => {
                clearHubSession()
                navigate('/', { replace: true })
              }}
            >
              Back to sign in
            </button>
            <p className="footer-note">
              Need help? <a href="mailto:support@gosnel.com">support@gosnel.com</a>
            </p>
          </>
        ) : (
          <p className="lead">Signing you in…</p>
        )}
      </div>
    </div>
  )
}
